<template>
    <div class="card-empty-state-challenge-list">
        <span class="card-empty-state-challenge-list__art"></span>
        <h2 class="card-empty-state-challenge-list__heading">{{ textHeading }}</h2>
        <p class="card-empty-state-challenge-list__desc">{{ textDesc }}</p>
        <button
            v-if="showButton"
            class="btn-empty-state-challenge"
            @click="routeToSelectUser">
            <svg class="btn-empty-state-challenge__icon" width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.4 11.9l2.16 3.6m0 0l2.88 2.16M5.56 15.5L3.4 17.66m-1.44 0L3.4 19.1m4.32-2.88L19.96 3.98V1.1h-2.88L4.84 13.34" stroke="#2779ED" stroke-width="2.16" stroke-linecap="round" stroke-linejoin="round"/><path d="M18.52 11.9l-2.16 3.6-2.88 2.16m6.48 0l-1.44 1.44 1.44-1.44zm-3.6-2.16l2.16 2.16-2.16-2.16zm-2.16.72L1.96 3.98V1.1h2.88l12.24 12.24" fill="#fff"/><path d="M18.52 11.9l-2.16 3.6m0 0l-2.88 2.16m2.88-2.16l2.16 2.16m1.44 0l-1.44 1.44m-4.32-2.88L1.96 3.98V1.1h2.88l12.24 12.24" stroke="#2779ED" stroke-width="2.16" stroke-linecap="round" stroke-linejoin="round"/></svg>
            <span class="btn-empty-state-challenge__text">Meydan Oku</span>
        </button>
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        props: {
            textHeading: {
                type: String,
                default: 'Lorem Ipsum Dolor',
            },
            textDesc: {
                type: String,
                default: 'Lorem ipsum dolor sit amet.'
            }
        },

        computed: {
            showButton(){
                let selectedFiltertag = this.$store.state.selectedFiltertagChallengeList;
                if(selectedFiltertag.type === 'all' || selectedFiltertag.type === 'ongoing'){
                    return true;
                }
                return false;
            }
        },

        methods: {
            routeToSelectUser(){
                this.$router.push('/challenge/select-user');
            }
        }
    };
</script>

<style scoped src="@/css/components/card-empty-state-challenge-list.css"></style>